<template>
    <div>
        <Toolbar>
            <template v-slot:right>
                <div class="btn-group">
                    <ToolbarLink v-if="Permission.VIEW_SUBSCRIPTION_COUPONS" :href="$route('subscriptions.coupons')">
                        <i class="fas fa-barcode mr-1"/>
                        {{ __('general.coupons') }}
                    </ToolbarLink>
                    <ToolbarLink v-if="Permission.VIEW_SUBSCRIPTION_FEATURES" :href="$route('subscriptions.features')">
                        <i class="fas fa-list mr-1"/>
                        {{ __('subscriptions.features') }}
                    </ToolbarLink>
                    <ToolbarLink v-if="Permission.VIEW_SUBSCRIPTION_BUNDLES" :href="$route('subscriptions.bundles')">
                        <i class="fas fa-boxes mr-1"/>
                        {{ __('subscriptions.bundles') }}
                    </ToolbarLink>
                </div>
            </template>
        </Toolbar>

        <Card>
            <template v-slot:title>{{ __('general.subscriptions') }}</template>
            <template v-slot:description>
                {{ __('actions.manage_thing', {thing: __('general.subscriptions')}) }}
            </template>
            <template v-slot:toolbar>
                <div class="d-flex flex-row">
                    <div class="pr-1 h-100">
                        {{ __('general.filter') }}:
                    </div>
                    <select class="form-control" @change="e => filterByBundle(e.target.value)">
                        <option :selected="initBundleSelection === null" :value="null">
                            Do not filter by bundle
                        </option>
                        <option v-for="(bundleName, bundleKey) in bundles"
                                :key="bundleKey"
                                :value="bundleKey"
                                :selected="initBundleSelection === bundleKey">
                            {{ bundleName }}
                        </option>
                    </select>
                </div>
            </template>

            <div class="table-responsive">
                <table class="table table-vertical-center table-hover">
                    <thead>
                    <tr>
                        <th>{{ __('general.user') }}</th>
                        <th>{{ __('subscriptions.booking') }}</th>
                        <th class="text-center">{{ __('subscriptions.payments') }}</th>
                        <th class="text-center">{{ __('general.status') }}</th>
                        <th class="text-center">{{ __('general.stores') }}</th>
                        <th class="text-center">{{ __('subscriptions.invoices') }}</th>
                        <th class="text-right">{{ __('general.created') }}</th>
                        <th class="text-right">{{ __('general.actions') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="sub in paginatedSubscriptions.data">
                        <td>
                            <UserLink :user="sub.user" show-email show-avatar/>
                        </td>
                        <td>
                            {{ __('subscriptions.bundle') }}:
                            {{ getTranslation(sub.subscribable.lang.name) || 'Unknown product' }}
                        </td>
                        <td class="text-center text-uppercase font-size-sm">
                            <i v-if="sub.customer.has_payments_configured" class="fas fa-check text-success"/>
                            <Dot v-else type="warning" title="Not configured"/>
                        </td>
                        <td class="text-center">
                            <ResponsiveSubscriptionStatus :subscription="sub"/>
                        </td>
                        <td class="text-center">
                            {{ sub.stores_count || '0' }}
                            <span class="font-weight-light mx-1">{{ __('general.of') }}</span>
                            {{ sub.paid_stores_count }}
                        </td>
                        <td class="text-center">
                            <CustomerInvoicesLink :total="sub.customer.invoices_count" :uid="sub.customer.uid"/>
                        </td>
                        <td class="text-right">
                            <DateResponsive :date="sub.created_at"/>
                        </td>
                        <td class="text-right">
                            <Link v-if="Permission.VIEW_ALL_SUBSCRIPTIONS"
                                  as="button"
                                  class="btn btn-xs px-4 btn-default btn-hover-primary"
                                  :href="$route('subscriptions.show', sub.id)"
                            >
                                <i class="fas fa-eye ml-1"/>
                            </Link>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <Pagination class="mb-3"
                        :pagination="paginatedSubscriptions"
                        :inertia-options="{only: ['paginatedSubscriptions']}"
                        disable-when-one-page
            />
        </Card>
    </div>
</template>

<script>
import Badge from "@components/Badge.vue";
import Pagination from "@components/TableComponents/Pagination.vue";
import {rewriteUrl} from "@composables/rewriteUrl";
import Price from "@components/Price.vue";
import { Link } from '@inertiajs/vue2';
import Center from "@components/Layout/Center.vue";
import UserLink from "@components/User/UserLink.vue";
import Card from "@components/Cards/Card.vue";
import Dot from "@components/Dot.vue";
import DateResponsive from "@components/DateResponsive.vue";
import ResponsiveSubscriptionStatus from "@components/Subscriptions/ResponsiveSubscriptionStatus.vue";
import CustomerInvoicesLink from "@components/Subscriptions/CustomerInvoicesLink.vue";
import Toolbar from "@components/Toolbar.vue";
import ToolbarLink from "@components/ToolbarLink.vue";
import {PermissionsMixin} from "@js/permissions";
import helperMethods from '@mixins/helperMethods'

export default {
    components: {
        ToolbarLink,
        Toolbar,
        CustomerInvoicesLink,
        ResponsiveSubscriptionStatus,
        DateResponsive,
        Dot,
        Card,
        UserLink,
        Center,
        Price,
        Pagination,
        Badge,
        Link
    },

    mixins: [PermissionsMixin, helperMethods],

    props: {
        paginatedSubscriptions: Object,
        bundles: Object,
        initBundleSelection: String
    },

    methods: {
        filterByBundle(bundleId) {
            rewriteUrl('bundle', bundleId)
            this.$inertia.reload({
                only: ['paginatedSubscriptions']
            })
        }
    }
};
</script>
